const initialState = {
  data: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    Panels: []
  },
  isLoading: false,
  hasErrored: false,
};

export default (state = initialState, action) => {
  //console.log(action);
  switch (action.type) {
    case '[PANEL] HAS_ERRORED':
      return { ...state, isLoading: false, data: initialState.data, hasErrored: true };
    case '[PANEL] IS_LOADING':
      return { ...state, hasErrored: false, data: initialState.data, isLoading: true };
    case '[PANEL] FETCH_SUCCESS':
      return { ...state, hasErrored: false, isLoading: false, data: action.data };
    case '[PANEL] COUNT_FAILS':
      return { ...state, countFails: action.countFails };
    default:
      return state;
  }
};
